import React, { useState } from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import InputText from "../../atomic/InputText/InputText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../atomic/Button/Button";
import FileUploadDesc from "../../atomic/FileUpload/FileUploadDesc";

const Root = styled.div`
  width: 100%;
  max-width: 1270px;
  margin-bottom: 40px;
  background-color: ${props => props.theme.backgroundColor};
  display: flex;
  flex-direction: column;
  padding: 20px;
  svg {
    margin-left: 5px;
  }
  textarea {
    outline: none;
  }
  label {
    margin: 5px 0px;
  }
`;

const MainText = styled.textarea`
  resize: none;
  letter-spacing: 0.01rem;
  line-height: 1.6;
  border: 1px solid #d7d7d7;
  padding: 10px 20px;
  min-height: 100px;
  font-weight: 400;
  font-size: 18px;
  margin-top: 5px;
`;

/* <SimpleDiv>
<SimpleLabel for="ActivityYoutube">
  Link to youtube video (optional)
</SimpleLabel>
<YoutubeVideo
  id="ActivityYoutube"
  onChange={id => setYoutubevideo(id)}
  videoLink={youtubevideo}
/>
</SimpleDiv> */

const ImageContent = styled.div`
  width: 100%;
  border: 1px solid ${props => props.theme.borderColor};
  margin: 10px 20px 10px 0;
  position: relative;
  background-color: ${props => props.theme.color5};
  textarea {
    border: 0px solid;
  }
`;

const FileAddMenu = styled.div`
  display: flex;
  margin-top: 20px;
  svg {
    margin-right: 5px;
  }
  button {
    display: flex;
    height: 50px;
    font-size: 15px;
    align-items: center;
    background-color: white;
    padding: 10px 20px;
    border-top: 1px solid ${props => props.theme.borderColor};
    border-left: 1px solid ${props => props.theme.borderColor};
    border-right: 1px solid ${props => props.theme.borderColor};
    margin-right: 10px;
    position: relative;
    top: 6px;
    left: 5px;
    cursor: pointer;
    outline: none;
  }
`;

const VideoAdd = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: #fff;
  padding: 20px 10px;
  border: 1px solid #eee;
  border-radius: 0 3px 3px;
  margin-left: 5px;
  margin-top: 5px;
  z-index: 1;
  button {
    margin-left: 10px;
  }
`;

const UpDown = styled.div`
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: 0 0;
  position: absolute;
  right: -10px;
  top: -5px;
  display: flex;
  flex-direction: column;
  z-index: 2;
  width: 27px;
  button {
    padding: 5px;
    font-size: 15px;
    margin-bottom: 5px;
    background-color: ${props => props.theme.borderColor};
    cursor: pointer;
    outline: none;
  }
  svg {
    margin-left: 0px;
  }
`;
export default withTheme(
  ({
    theme,
    content = {},
    uploadFolder,
    onChange,
    contentLabel = "Content",
    notitle
  }) => {
    const [fileType, setFileType] = useState("image");
    const [videoLink, setVideoLink] = useState("");
    return (
      <Root>
        {!notitle && <label>Title</label>}
        {!notitle && (
          <InputText
            value={content.title}
            onChange={e => onChange({ ...content, title: e.target.value })}
          />
        )}
        <label>
          {contentLabel}
          <a href="https://www.markdownguide.org/basic-syntax/" target="_blank">
            <FontAwesomeIcon
              icon={["fas", "question-circle"]}
              size="1x"
              color={theme.color2}
            />
          </a>
        </label>
        <MainText
          rows={Math.max(6, (content.instructions || "").split("\n").length)}
          value={content.instructions}
          onChange={e => onChange({ ...content, instructions: e.target.value })}
        ></MainText>
        <FileAddMenu>
          <button
            style={
              fileType === "image"
                ? { borderTop: "3px solid " + theme.borderColor, zIndex: 2 }
                : { zIndex: "0" }
            }
            onClick={() => setFileType("image")}
          >
            <FontAwesomeIcon
              icon={["fas", "camera"]}
              size="1x"
              color={theme.color2}
            />{" "}
            Add Photo
          </button>
          <button
            style={
              fileType === "video"
                ? {
                    borderTop: "3px solid " + theme.borderColor,
                    zIndex: 2
                  }
                : {}
            }
            onClick={() => setFileType("video")}
          >
            <FontAwesomeIcon
              icon={["fas", "video"]}
              size="1x"
              color={theme.color2}
            />{" "}
            Add Video
          </button>
        </FileAddMenu>
        {fileType === "image" && (
          <FileUploadDesc
            noEdit
            folder={uploadFolder}
            onUpload={(url, width, height, contentType, fileName) => {
              onChange({
                ...content,
                media: [
                  { url, width, height, contentType, fileName, type: "image" }
                ].concat(content.media || [])
              });
            }}
          />
        )}
        {fileType === "video" && (
          <VideoAdd>
            <InputText
              onChange={e => setVideoLink(e.target.value)}
              videoLink={videoLink}
              placeholder={"e.g.: https://www.youtube.com/watch?v=eGsp7k4US1M"}
            />
            <Button
              inverted
              onClick={() => {
                const link = videoLink;
                setVideoLink("");
                onChange({
                  ...content,
                  media: [
                    {
                      url: link,
                      type: "video"
                    }
                  ].concat(content.media || [])
                });
              }}
            >
              Submit
            </Button>
          </VideoAdd>
        )}

        {(content.media || []).map((im, ind) => {
          return (
            <ImageContent key={ind}>
              <UpDown>
                <button
                  onClick={() => {
                    if (ind == 0) {
                      return;
                    }
                    const result = content.media.map(m => m);
                    result[ind] = result[ind - 1];
                    result[ind - 1] = im;
                    onChange({
                      ...content,
                      media: result
                    });
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "arrow-up"]}
                    size="1x"
                    color={theme.color2}
                  />
                </button>
                <button
                  onClick={() => {
                    if (ind == content.media.length - 1) {
                      return;
                    }
                    const result = content.media.map(m => m);
                    result[ind] = result[ind + 1];
                    result[ind + 1] = im;
                    onChange({
                      ...content,
                      media: result
                    });
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "arrow-down"]}
                    size="1x"
                    color={theme.color2}
                  />
                </button>
              </UpDown>
              <FileUploadDesc
                key={im.url}
                image={im.url}
                content={im}
                type={im.type}
                setContent={c => {
                  if (!c) {
                    onChange({
                      ...content,
                      media: content.media.filter(m => m.url !== im.url)
                    });
                  } else {
                    onChange({
                      ...content,
                      media: content.media.map(m => (m.url === c.url ? c : m))
                    });
                  }
                }}
              />
            </ImageContent>
          );
        })}
      </Root>
    );
  }
);
